/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">Edit Level</h4>
        <div>
            <!-- Default form login -->
            <form class="border border-light p-5">
                <div class="row">
                    
                    <div class="form-group col-md-6">
                        <label>Title</label>
                        <input type="text" ref="title" :value="category.title" class="form-control mb-4" placeholder="Title">
                    </div>
                   
                    <div class="form-group col-md-6">
                        <button class="btn btn-info btn-block my-4" @click.prevent="updateLevel()">Update Level</button>
                    </div>
                </div>

            </form>
            <!-- Default form login -->
        </div>
    </div>
</div>
</template>

<script>
import axios from "axios"
export default {
    name: 'EditCategory',
    components: {

    },
    data() {
        return {
            categoryId: this.$route.params.categoryId,
            fastAdminToken : localStorage.getItem("fastAdminToken"),
            category:[],
        }
    },
    methods: {
        updateLevel() {
            let data = {
                title: this.$refs.title.value,
            }
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }
            this.$toast.open({
                message: "Processing : Updating Level Please Wait...",
                type: 'info'
            })
            axios.post(this.$apiURI + "/category/" + this.categoryId + "/update", data, config)

                .then((response) => {
                    if (response.data.error) {
                        this.$toast.open({
                            message: "Error : " + response.data.message,
                            type: 'error'
                        });
                    } else {
                        this.$toast.open({
                            message: "Level Updated Successfully",
                            type: 'success'
                        })
                    }

                }).catch((error) => {
                    this.$toast.open({
                        message: "Error : " + error.response.data.message,
                        type: 'error'
                    });
                })
        }
    },
    mounted(){
        this.$toast.open({
            message: "Processing : Loading Plan Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        axios.get(this.$apiURI + "/category/"+this.categoryId, config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.category = response.data.data
                    // this.planTarget = response.data.data.target
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    }

}
</script>
